<template>
  <div
    v-if="!isHomePage"
    class="custom-navbar"
    :class="{
      'navbar-central': isOtherNavbar,
      'navbar-vendorearch': isVendorearch,
    }"
  >
    <VanNavBar
      :title="title"
      :fixed="true"
      :left-arrow="showLeftArrow && !isVendorearch"
      placeholder
      clickable
      @click-left="onBack"
    >
      <template v-if="isVendorearch" #left>
        <div class="vendorearch-navbar-left">
          <van-icon name="arrow-left" class="van-nav-bar__arrow" @click="onBack" />
          <img :src="vendorearchLogoUrl" alt="logo" class="vendorearch-navbar-logo" />
        </div>
      </template>
      <template v-if="isRecord" #right>
        <div class="record-img" @click="changePage">
          <img src="@/assets/record.png" />
        </div>
      </template>
    </VanNavBar>
  </div>
</template>

<script setup lang="ts">
import { rootRouteList } from '@/config/routes'

const route = useRoute()
const router = useRouter()
const { t } = useI18n()

const isHomePage = computed(() =>
  ['Home', 'Activity', 'Profile', 'game-id', 'Saque', 'Registros', 'Games'].includes(route.name)
)
const isRecord = computed(() => ['WithdrawalHistory', 'DepositHistory'].includes(route.name))

const isOtherNavbar = computed(() => ['AccountCenter'].includes(route.name as string))
const isVendorearch = computed(() => route.name === 'vendorearch')
const vendorearchLogoUrl = computed(() => getImageUrlWithCDN_TEST('/skin_theme/logo_full_name.png'))
/**
 * Get page title
 * Located in src/locales/json
 */
const title = computed(() => {
  if (route.name) {
    return t(`navbar.${route.name}`)
  }

  return t('navbar.Undefined')
})

/**
 * Show the left arrow
 * If route name is in rootRouteList, hide left arrow
 */
const showLeftArrow = computed(() => {
  if (route.name && rootRouteList.includes(route.name)) {
    return false
  }

  return true
})

function onBack() {
  try {
    if (route.name === 'vendorearch') {
      router.push({ name: 'Home' })
      return
    }
    if (window.history.state.back) {
      history.back()
    } else {
      router.replace('/')
    }
  } catch (error) {
    window.location.href = '/'
  }
}

function changePage() {
  if (route.name == 'DepositHistory') {
    router.push({ name: 'WithdrawalHistory' })
  } else {
    router.back()
  }
}
</script>
<style lang="scss" scoped>
:deep(.van-nav-bar__title) {
  font-size: 15px;
}
.custom-navbar {
  :deep(.van-hairline--bottom:after) {
    border-width: 0 !important;
  }
}

.navbar-central {
  :deep(.van-nav-bar) {
    background: linear-gradient(to right, #49c755, #0f9957) !important;
  }
}

.navbar-vendorearch {
  :deep(.van-nav-bar),
  :deep(.van-nav-bar__content),
  :deep(.van-nav-bar__left) {
    overflow: visible;
  }
}

.vendorearch-navbar-left {
  display: flex;
  align-items: center;
  height: 100%;
}

.vendorearch-navbar-logo {
  width: 131px;
  // height: 135px;
  object-fit: contain;
  flex-shrink: 0;
  margin-left: 2px;
}

.record-img {
  width: 17.5px;
}
</style>
